import HeroBanner from "./components/HeroBanner";
import AdvantagesSection from "./components/AdvantagesSection";
import SolutionsSection from "./components/SolutionsSection";
import CasesSection from "./components/CasesSection";
import CertificationsSection from "./components/CertificationsSection";
import CtaSection from "./components/CtaSection";
import ContactForm from "./components/ContactForm";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSEO } from "@/utils/seo";
import { bootstrapHome } from "@/api/homeApi";
import FaqBlock from "@/components/feature/FaqBlock";

// 在首页组件求值阶段就触发一次聚合预取（仅一次），
// 确保早于子组件的 effect 注册各子缓存键的进行中 Promise。
let bootstrapStarted = false;
function ensureBootstrap() {
  if (bootstrapStarted) return;
  bootstrapStarted = true;
  bootstrapHome().catch(() => {});
}

export default function HomePage() {
  // 渲染阶段同步触发（早于子组件 effect），使子组件请求复用同一聚合请求
  ensureBootstrap();

  const { hash } = useLocation();

  useSEO({
    title: "欧格登智能 - 企业安全解决方案 | 信息安全 · IT基础架构 · 云信达 · AI业务",
    description:
      "欧格登智能（ogolden.com）是专业的企业安全解决方案提供商，专注信息安全、IT基础架构、云信达、AI业务四大领域，为企业提供规划设计、建设实施到运维托管的全生命周期服务，已服务500+行业头部客户。立即联系欧格登获取定制化安全方案。",
    keywords: [
      "欧格登智能",
      "欧格登企业安全",
      "欧格登解决方案",
      "零信任",
      "SOC安全运营",
      "等保三级",
      "数据中心",
      "超融合",
      "视频监控",
      "楼宇自控",
    ],
    path: "/",
    pageType: "HOME",
    // 首页不传 jsonLd：Organization + WebSite 由构建期 prepareAppShell() 注入 index.html 头部（Site_JsonLd，需求 3.1），
    // 页面级再写一份 Organization 会让 "/" 出现两个 Organization 段。
  });

  useEffect(() => {
    if (hash) {
      // 等待所有 section 渲染完成后再滚动
      const timer = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [hash]);

  return (
    <main>
      <HeroBanner />
      <AdvantagesSection />
      <SolutionsSection />
      <CasesSection />
      <CertificationsSection />
      <CtaSection />
      <ContactForm />
      <FaqBlock scope="HOME" />
    </main>
  );
}
